// Darken (negative `percent`) or lighten a colour by adding `percent` to each RGB channel —
// the box border is the fill darkened by 20. VERBATIM from issue-analysis's BoxPlot.vue
// (IA_ABSORPTION_PLAN Phase 4 step 12d), except that the colour it falls back to for an
// unparseable input is passed in (the `chart.boxPlot.borderFallback` theme token) instead of
// a hex literal. Package-private.

/**
 * @param {string} color     `#rrggbb` or `rgb(r, g, b)`
 * @param {number} percent   added to each channel, clamped to 0–255
 * @param {string} fallback  returned for an empty or unparseable colour
 * @returns {string} `#rrggbb`
 */
export function adjustColorShade(color, percent, fallback) {
  if (!color) return fallback;

  // If color is in hex format
  let R, G, B;
  if (color.startsWith('#')) {
    const hex = color.substring(1);
    R = parseInt(hex.substring(0, 2), 16);
    G = parseInt(hex.substring(2, 4), 16);
    B = parseInt(hex.substring(4, 6), 16);
  }
  // If color is in rgb format
  else if (color.startsWith('rgb')) {
    const rgb = color.match(/\d+/g);
    if (rgb && rgb.length >= 3) {
      R = parseInt(rgb[0]);
      G = parseInt(rgb[1]);
      B = parseInt(rgb[2]);
    } else {
      return fallback;
    }
  } else {
    return fallback;
  }

  // Adjust the color
  R = Math.max(0, Math.min(255, R + percent));
  G = Math.max(0, Math.min(255, G + percent));
  B = Math.max(0, Math.min(255, B + percent));

  // Convert back to hex
  return `#${((1 << 24) + (R << 16) + (G << 8) + B).toString(16).slice(1)}`;
}
